import { findOptions } from "../../../../../helpers/StringHelper";

export const mapSubjects = (data, options, namespace) => {
  if (namespace === 'victims') {
    const {
      gender,
      categoriesOptions,
    } = options || {};

    return data.map(subject => {
      return {
        ...subject,
        dbId: subject.id,
        title: subject.name,
        date: subject.updatedAt,
        incidentCount: subject.incidentCount ? subject.incidentCount : '--',
        assistedCount: subject.assistedCount ? subject.assistedCount : '--',
        id: subject.datastakeId,
        age: subject.age || '--',
        gender: findOptions(subject.gender, gender) || '--',
        category: findOptions(subject.category, categoriesOptions) || '--',
      }
    })
  }

  if (namespace === 'initiatives') {
    const {
      initiativesOptions,
      initiativesScopeOptions,
    } = options || {};

    return data.map(subject => {
      return {
        ...subject,
        dbId: subject.id || '--',
        title: subject.name || '--',
        id: subject.datastakeId || '--',
        type: subject.type ? findOptions(subject.type, initiativesOptions) : '--',
        name: subject.name || '--',
        primaryOrg: typeof subject.primaryOrg === 'string' ? subject.primaryOrg : '--',
        intiativesScope: Array.isArray(subject.intiativesScope) && subject.intiativesScope.length ?
          subject.intiativesScope.map((s) => findOptions(s, initiativesScopeOptions))
          : '--'
      }
    })
  }

  if (namespace === 'locations') {
    const {
      countries,
      locationCategory,
    } = options || {};

    return data.map(subject => {
      const level1 = (subject?.linking?.SCL || {})[subject.administrativeLevel1];
      const level2 = (subject?.linking?.SCL || {})[subject.administrativeLevel2];

      return {
        ...subject,
        dbId: subject.id,
        id: subject.datastakeId,
        title: subject.name,
        adminLevel1: level1?.name || '--',
        adminLevel2: level2?.name || '--',
        country: findOptions(subject.country, countries) || '--',
        category: findOptions(subject.category, locationCategory) || '--',
      }
    })
  }

  if (namespace === 'pictures' || namespace === 'documents') {
    return data.map(subject => {
      return {
        ...subject,
        dbId: subject.id,
        id: subject.datastakeId,
        title: subject.name,
        files: subject.documents || subject.pictures,
      }
    })
  }

  if (namespace === 'stakeholders') {
    const {
      countries,
      categoriesOptions,
      subCategoriesOptions,
    } = options || {};

    return data.map(subject => {
      return {
        ...subject,
        dbId: subject.id,
        title: subject.name,
        id: subject.datastakeId,
        country: findOptions(subject.country, countries) || '--',
        category: findOptions(subject.category, categoriesOptions) || '--',
        subCategory: findOptions(subject.subCategory, subCategoriesOptions) || '--',
      }
    })
  }

  return data;
}

export const getFilterOptions = (options, view) => {
  switch (view) {
    case 'victims':
      return {
        category: options?.categoriesOptions || [],
        gender: options?.gender || [],
      };
    case 'locations':
      return {
        country: options?.countries || [],
        category: options?.locationCategory || [],
      };
    case 'initiatives':
      return {
        type: options?.initiativesOptions || [],
        scope: options?.initiativesScopeOptions || [],
      };
    case 'stakeholders':
      return {
        country: options?.countries || [],
        category: options?.categoriesOptions || [],
        subCategory: options?.subCategoriesOptions || [],
      };
    default:
      return {};
  }
}

export const getFiltersConfig = () => ({
  name: '',
  datastakeId: '',
});

export const getSelectFiltersConfig = (namespace) => {
  const config = [
    {
      key: 'country',
      type: 'select',
      label: 'Country',
      namespaces: ['locations', 'stakeholders'],
      placeholder: (t) => t('Country'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
    },
    {
      type: 'ajaxSelect',
      namespaces: ['locations'],
      key: 'administrativeLevel1',
      label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
        const { administrativeLevel1 } = options;

        if (administrativeLevel1) {
          if (options.country) {
            const _item = administrativeLevel1[filters.country];
            if (_item) {
              if (_item[language]) {
                return _item[language]
              }
            }
          }
        }

        return t('Province');
      },
      placeholder: (t) => t('Province'),
      filters: (data) => ({
        country: data.country,
        level: 'level_1',
      }),
      show: (data) => !!!data.country,
      disabled: (data) => !!!data.country,
      mapper: { label: "name", value: "id" },
      method: 'getOptions',
      entity: 'AdministrativeLevel',
      style: { flex: 1 },
      labelStyle: { flex: 1 },
    },
    {
      key: 'administrativeLevel2',
      type: 'ajaxSelect',
      namespaces: ['locations'],
      label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
        const { administrativeLevel2 } = options;

        if (administrativeLevel2) {
          if (options.country) {
            const _item = administrativeLevel2[filters.country];
            if (_item) {
              if (_item[language]) {
                return _item[language]
              }
            }
          }
        }

        return t('Territory');
      },
      placeholder: (t) => t('Territory'),
      filters: (data) => ({
        country: data.country,
        level: 'level_2',
        administrativeLevel1: data.administrativeLevel1,
      }),
      disabled: (data) => !(data.country && data.administrativeLevel1),
      show: (data) => !(data.country && data.administrativeLevel1),
      mapper: { label: "name", value: "id" },
      method: 'getOptions',
      entity: 'AdministrativeLevel',
      style: { flex: 1 },
      labelStyle: { flex: 1 },
    },
    {
      key: 'category',
      type: 'select',
      label: 'Category',
      placeholder: (t) => t('Category'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
      namespaces: ['victims', 'locations', 'stakeholders'],
    },
    {
      key: 'subCategory',
      type: 'select',
      label: 'Sub Category',
      placeholder: (t) => t('Sub Category'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      show: (data) => !!!data.category,
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
      filterOptions: (val) => {
        if (val) {
          const { option, filters } = val
          if (filters && option) {
            const { filters: optionFilters } = option;
            if (Array.isArray(optionFilters) && optionFilters.length) {
              const { value, condition } = optionFilters[0];
              if (condition === 'includes') {
                return value.includes(filters.category);
              }
            }
          }
        }
        return true;
      },
      namespaces: ['stakeholders'],
    },
    {
      key: 'timeframe',
      namespaces: ['pictures', 'documents'],
      type: 'timeframe',
      label: 'Timeframe',
      style: { flex: 1 },
    },
    {
      key: 'gender',
      type: 'select',
      label: 'Gender',
      placeholder: (t) => t('Gender'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
      namespaces: ['victims'],
    },
    {
      key: 'type',
      type: 'select',
      label: 'Type',
      placeholder: (t) => t('Type'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
      namespaces: ['initiatives'],
    },
    {
      key: 'scope',
      type: 'select',
      label: 'Scope of the initiative',
      placeholder: (t) => t('Scope of the initiative'),
      style: { flex: 1 },
      labelStyle: { flex: 1 },
      getLabel: (option) => option.label,
      getValue: (option) => option.value,
      namespaces: ['initiatives'],
    },
  ];

  return config.filter((v) => v.namespaces.includes(namespace)).reduce((all, item) => {
    all[item.key] = item;
    return all;
  }, {});
};

export const getCheckboxConfig = () => ({
  name: 'Name',
  datastakeId: 'ID',
});

export const getDefaultSelectOptions = (namespace) => {
  const _options = getFilterOptions({}, namespace);

  return Object.keys(_options).reduce((all, key) => {
    all[key] = [];
    return all;
  }, {});
}
